$(function() {
  const BaseModule = require('_base/base')

  class Fader extends BaseModule {
    preInit() {
      this.CLASS_ACTIVE = 'is__active'
      this.CLASS_ACTIVE_RIGHT_NOW = 'is__activeRightNow'
    }

    postInit() {
      var module = this

      var $animatedGifs = module.$el
        .find('.img, .image, img')
        .filter('[data-src$=".gif"]')
        .filter((_, el) => !!$(el).find('.image-gifDouble').length)

      if ($animatedGifs.length) {
        module.gifs = []

        $(document).on('pedantFreeze', function() { module.isFreezed = true })
        $animatedGifs.each(function() {
          const $gif = $(this)

          module.gifs.push({
            $el: $gif,
            src: $gif.attr('data-src'),
          })

          $gif.addClass('is__ready is__retinafied is__gifImage')
        })
      }

      module.switchOn = module.$el.data('switch-on')

      module.isActive = false
      module.randomVersionIndex = 0

      module.$spread.on('anchor', function(e, data) {
        requestAnimationFrame(function() {
          module.draw(data)
        })
      })

      module.$spread.on('spreadDevisualized', module.disable.bind(module))
    }

    disable() {
      if (this.isActive) {
        this.isActive = false
        this.$el.removeClass(this.CLASS_ACTIVE)

        if (this.gifs) this.gifs.forEach(this.cleanGif)
      }
    }

    draw(data) {
      var module = this

      if (data.id >= module.switchOn) {
        if (!module.isActive) {
          module.isActive = true
          module.$el.addClass(module.CLASS_ACTIVE)
        }
      } else {
        module.disable()
      }

      module.$el.toggleClass(module.CLASS_ACTIVE_RIGHT_NOW, data.id == module.switchOn)

      if (module.isActive && !module.isFreezed && module.switchOn === +data.id) {
        module.resetGif(data)
      }
    }

    resetGif(data) {
      var module = this

      if (module.gifs && data.direction > -1) {
        module.gifs.forEach(function(gif) {
          if (module.spread._book.isOnMobileDevice) {
            requestAnimationFrame(module.reloadGif.bind(module, gif))
          } else {
            module.reloadGif(gif)
          }
        })
      }
    }

    cleanGif(gif) {
      gif.$el.css({ 'background-image': 'none' })
    }

    reloadGif(gif) {
      this.randomVersionIndex++

      gif.$el.css({
        'background-image': 'url(' + gif.src + '?v=' + this.randomVersionIndex + ')',
      })
    }
  }

  $('.js__fader').each(function() {
    new Fader($(this))
  })
})
